import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
} from "reactstrap";
import useUser from "../../../hooks/useUser";
import useProducts from "../../../hooks/useProducts";
import Select from "react-select";
import Swal from "sweetalert2";

const Tipo = [
  { value: "validado", label: "Validado" },
  { value: "no validado", label: "No validado" },
  { value: "en espera", label: "En espera" },
];

export default function ModalAdd({
  ModalStatus,
  toggleStatus,
  Id,
  Status,
  Justificacion,
  setId,
  setStatus,
  setJustificacion,
  RegistrosGetService,
}) {
  const { tokenFull, IdUser } = useUser();
  const { success, message, error, RegistroUpdateService } = useProducts();
  const [SelectedStatus, setSelectedStatus] = useState("");

  useEffect(() => {
    const date = new Date();
    const mes = date.getMonth() + 1;
    const mesActual = mes < 10 ? `0${mes}` : mes;

    RegistrosGetService({ IdUser, tokenFull, mesActual });
  }, [RegistrosGetService]);

  useEffect(() => {
    if (success == true) {
      const date = new Date();
      const mes = date.getMonth() + 1;
      const mesActual = mes < 10 ? `0${mes}` : mes;

      RegistrosGetService({ IdUser, tokenFull, mesActual });
    }
  }, [RegistrosGetService, success]);

  const actualizarStatus = () => {
    const data = new FormData();
    data.append("registro_id", Id);
    data.append("status", Status);
    data.append("justificacion", Justificacion);

    RegistroUpdateService(data, tokenFull);

    Swal.fire({
      html: "Espere por favor...",
      timer: 2000,
      confirmButtonColor: "#3b82f6",
      timerProgressBar: true,
    });

    toggleStatus();
  };

  useEffect(() => {
    if (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        confirmButtonColor: "#3b82f6",
        text: message,
      });
    }
  }, [message, error]);

  useEffect(() => {
    if (success) {
      Swal.fire({
        icon: "success",
        title: "Exito",
        confirmButtonColor: "#3b82f6",
        text: message,
      });
    }
  }, [message, success]);

  return (
    <>
      <Modal isOpen={ModalStatus} toggle={toggleStatus} size="lg">
        <ModalHeader toggle={toggleStatus}>Compra realizada</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-12">
              <label>Status</label>
              <Select
                value={SelectedStatus}
                onChange={(e) => {
                  setStatus(e.value);
                  setSelectedStatus(e);
                }}
                options={Tipo}
                placeholder={Status ? Status : "Tipo"}
              />
            </div>
          </div>
          {Status == "no validado" ? (
            <div className="row">
              <div className="col-md-12">
                <label>Justificación</label>
                <textarea
                  className="form-control"
                  rows="5"
                  value={Justificacion}
                  onChange={(e) => setJustificacion(e.target.value)}
                ></textarea>
              </div>
            </div>
          ) : (
            ""
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            className="btn btn-primary"
            onClick={() => actualizarStatus()}
          >
            Actualizar
          </Button>{" "}
        </ModalFooter>
      </Modal>
    </>
  );
}
